import moment from "moment";
import { createContext } from "react";

export const defaultCalendarValues = {
  events: [

  ],
  rawEvents: [],
  openDates: [],
  resetOpenDates: false,
  calendarDate: moment().format('YYYY-MM-DDTHH:mm'),
  changeDate: false,
  currentView: 'week',
  refreshCategories: false,
}


const CalendarContext = createContext(
  { set: undefined, get: undefined }
);

export default CalendarContext 
